import React from 'react';
import { useParams } from 'react-router-dom';

function Caso() {
    const { id } = useParams();

    return (
        <div>
            <h1>Detalles del Caso</h1>
            <p>Mostrando información para el caso con ID: {id}</p>
            {/* Aquí puedes hacer una llamada a la API o buscar los datos correspondientes al caso */}
        </div>
    );
}

export default Caso;